<nz-layout id="purchase-invoice-today">
  <div class="purchase-invoice-today-header">
    <div class="row p-0 m-0">
      <div class="col-6 p-0 m-0 d-flex align-items-center justify-content-between">
        <span class="title"><b>{{'Nhóm tin tức'}}</b></span>
        <div class="search">
          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" nz-input placeholder="Tìm kiếm tên tin tức" [(ngModel)]="searchNameProduct"
              (keyup)="checkKey($event)" (keyup.enter)="onSearchNews(pageCurrent)" />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span (click)="onSearchNews(pageCurrent)" nz-icon nzType="search"></span>
          </ng-template>
        </div>
      </div>
      <div class="col-6 p-0 m-0 d-flex align-items-center justify-content-end">
        <button class="_btn _btn_soft d-flex align-items-center right-all-content mr-2" nz-button nzType="default"
          (click)="softProducts()">
          <i class="bi bi-filter"></i>
          {{'Sắp xếp danh mục ' + (isASC ? 'A-Z' : 'Z-A')}}
        </button>
      </div>
    </div>
  </div>
  <div style="margin-top: 16px;">
    <nz-table [nzScroll]="{ y: tableHeight }" [nzData]="newsShow" #tableSales [nzShowPagination]="false" [nzFrontPagination]="false"
      nzShowSizeChanger>
      <thead class="_thead">
        <tr>
          <th nzWidth="10%" nzAlign="center"><b>Ảnh</b></th>
          <th nzWidth="50%" nzAlign="left"><b>Tên sản phẩm</b></th>
          <th nzWidth="15%" nzAlign="left"><b>Danh mục</b></th>
          <th nzWidth="25%" nzAlign="center"><b>Ẩn/ Hiện</b></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of newsShow; trackBy: trackByFn">
          <tr>
            <td>
              <div class="image d-flex align-items-center justify-content-center">
                <img onerror="this.src='assets/root/icon/management/image_default.svg'" [src]="item.img" [alt]="item.name"
                  width="40px" height="40px">
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="margin-left: 20px; font-weight: 600;">
                <span>{{ item.title }}</span>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="margin-left: 20px;">
                <span>{{ item.category_name }}</span>
              </div>
            </td>
            <td nzAlign="center">
              <div class="status">
                <label class="switch">
                  <nz-switch [(ngModel)]="item[this.data._id+'_hidden']"
                    (ngModelChange)="updateShowWeb(item._id,$event)"></nz-switch>
                </label>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    <div *ngIf="newsShow.length" class="pagination mt-3">
      <div class="pagination-list-button">
        <div class="page-start pagiItem" (click)="gotoPreviousPage()">Trước</div>
        <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent > 3" (click)="transferFn(1)">
          1
        </div>
        <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent > 3">
          ...
        </div>
        <div *ngFor='let page of pageShowChoose ;let i = index'>
          <div class="page-number pagiItem" *ngIf="page <= totalPages && page > 0"
            [ngClass]="{'active': page == pageCurrent}" (click)="transferFn(page)">
            {{page}}
          </div>
        </div>
        <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent < totalPages-1">
          ...
        </div>
        <div class="page-number pagiItem" *ngIf="totalPages > 3 && pageCurrent < totalPages-1"
          (click)="transferFn(totalPages)">
          {{totalPages}}
        </div>
        <div class="page-end pagiItem" (click)="gotoNextPage()">Sau</div>
        <button nz-popover [nzPopoverTitle]="'Tối đa ' +  totalPages" [nzPopoverContent]="contentTemplate"
          class="page-go pagiItem" nzPopoverPlacement="top">
          Tới trang
        </button>
      </div>
      <ng-template #contentTemplate>
        <div class="input-container">
          <input placeholder="Nhập trang cần tới" type="number" [(ngModel)]="pageGoto" />
          <div class="goto-page" (click)="transferFn((pageGoto <= totalPages && pageGoto > 0)  ? pageGoto : 1)">Tới
          </div>
        </div>
      </ng-template>
    </div>
  </div>


</nz-layout>
